import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { truncateString } from "@utils"
import { dsColorNew } from "@palette"


export default function ReportFormDrawerCsvFileName({ file }) {

	if (!file?.name || !file?.size) return null

	return <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
		<IconSeeker icon="file-csv" sx={{ fontSize: 18, color: dsColorNew.appBlue }}/>
		<Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle, whiteSpace: 'nowrap' }} title={file?.name}>
			{truncateString(file?.name || "", 40)}
		</Typography>
		<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, whiteSpace: 'nowrap' }}>{file?.size} KB</Typography>
	</Box>
}
